<dx-tag-box
  #tagBox
  [height]="height"
  [(value)]="value"
  [acceptCustomValue]="acceptCustomValue"
  [dataSource]="itemsList"
  (onCustomItemCreating)="onCustomItemCreating($event)"
  (onValueChanged)="onValueChanged()"
  (onChange)="onTagBoxTextChange($event)"
  (onKeyUp)="onKeyUp($event)">
</dx-tag-box>